// extracted by mini-css-extract-plugin
export var menuContainer = "header-module--menuContainer--39d5c";
export var mobileMenuContainer = "header-module--mobileMenuContainer--76bdb";
export var mobileMenuIconContainer = "header-module--mobileMenuIconContainer--6e008";
export var navigationIcons = "header-module--navigationIcons--f1d00";
export var navigationItems = "header-module--navigationItems--18df8";
export var navigationLogo = "header-module--navigationLogo--47cdb";